import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function TextIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 0H11V2H16V0Z" />
        <path d="M16 4H11V6H16V4Z" />
        <path d="M11 8H16V10H11V8Z" />
        <path d="M16 12H0V14H16V12Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 9H6.86554L6.0249 7H2.9751L2.13446 9H0L3.3631 1H5.6369L9 9ZM4.5 3.37207L3.81573 5H5.18427L4.5 3.37207Z"
        />
      </svg>
    </Icon>
  );
}
